module.exports = __webpack_public_path__ + "7c48a3af67d23c9d9b2953054096da8c.pdf";